export interface AssetAddress {
    address?: string;
    city?: string;
    state?: string;
    country?: string;
    zipCode?: string;
}

export interface GeocodeResult {
    location: string;
    geometry: google.maps.LatLng;
    fullAddressQuery: string;
}

export const manualGeocode = (
    assetData: AssetAddress
): Promise<GeocodeResult> => {
    return new Promise((resolve, reject) => {
        // 1. Validate input
        if (!assetData?.address && !assetData?.city) {
            return reject("Insufficient address data for geocoding");
        }

        const queryParts = [
            assetData.address,
            assetData.city,
            assetData.state,
            assetData.country,
            assetData.zipCode
        ].filter(part => part && part.trim() !== "");

        const fullAddressQuery = queryParts.join(", ");

        const geocoder = new google.maps.Geocoder();

        geocoder.geocode({ address: fullAddressQuery }, (results, status) => {
            if (status === "OK" && results?.[0]) {
                const geometry = results[0].geometry.location;

                resolve({
                    location: `${geometry.lat()},${geometry.lng()}`,
                    geometry,
                    fullAddressQuery
                });
            } else {
                reject(`Geocoding failed: ${status}`);
            }
        });
    });
};

export const isGooglePlacesAvailable = () => {
    return (
      typeof window !== "undefined" &&
      typeof window.google !== "undefined" &&
      typeof google.maps !== "undefined" &&
      typeof google.maps.places !== "undefined"
    );
};
